import { useQuery } from '@apollo/client';
import type { AudiencePricing } from '@openx/types/targeting/audience.ts';
import type { UseGetAudienceMultiproviderInfo } from '@openx/types/targeting/targetingHookTypes.ts';
import { GetAudienceDocument } from '../../../graphql/query/audiences/GetAudience.generated.tsx';

export const useGetAudienceMultiproviderInfo: UseGetAudienceMultiproviderInfo = ({
  selectedAudienceOption,
  values,
}) => {
  const audienceId = values?.[0] ?? '';
  const skipQuery = !selectedAudienceOption || selectedAudienceOption !== 'openaudience_custom' || !audienceId;

  const { data: { audience_by_pk: audience } = {}, loading: loadingAudienceCheck } = useQuery(GetAudienceDocument, {
    skip: skipQuery,
    variables: {
      id: audienceId?.replace('openaudience-', ''),
    },
  });

  const hasMultiProviderPricingData = !!audience?.is_multi_partner;

  return {
    hasMultiProviderPricingData,
    pricingInfo: audience?.pricing as AudiencePricing,
    loadingAudienceCheck,
  };
};
